module.exports = __webpack_public_path__ + "img/call-types-bg.fe8dd775.svg";